<template>
	<div>
		<form id="signup" @submit.stop.prevent="signup">

			<div id="signup-step-pos-dummy" :class="{ 'signup-started': signupInProgress }"></div>

			<div id="signup-step" :class="[{ 'init': signupStepElInit }, { 'in-transition': inTransition }, { 'signup-started': signupInProgress }, { 'active-preview-request': activePreviewRequest }]" v-if="!signupCompleted">

				<div class="arrow-up"></div>

				<div class="inner-wrap">

					<div id="loading" v-show="uiLocked || inTransition">
						<div uk-spinner="ratio: 4" style="color:#EEE"></div>
					</div>

					<div class="signup-step__start uk-padding" v-show="isCurrentStep('start')">
						<div id="special-deal-label" class="uk-label uk-label-success uk-margin-bottom" v-if="specialDealRegularPrice && specialDealLabel">{{ specialDealLabel }}</div>

						<div class="uk-light">
							<h2>DEINE immonex ONE Website</h2>

							<div class="uk-margin-large-bottom" uk-grid>
								<div class="uk-width-1-2@m">
									<p>
										...ist dank &bdquo;<span class="text-highlight">Echtzeit-Einrichtung</span>&ldquo; in wenigen Minuten online.
										<meta-info type="toggle">
											Kontaktdaten eingeben <span class="icon-check" uk-icon="chevron-right"></span>
											Logo und Portraitfoto hochladen (optional) <span class="icon-check" uk-icon="chevron-right"></span>
											Anmeldung per E-Mail-Link bestätigen <span class="icon-check" uk-icon="chevron-right"></span>
											Zugangsdaten in der Maklersoftware hinterlegen und Angebote via OpenImmo-Schnittstelle übertragen <span class="icon-check" uk-icon="chevron-right"></span>
											Textinhalte individuell anpassen <span class="icon-check" uk-icon="check"></span><span class="uk-text-success">Fertig!</span>
										</meta-info>
									</p>

									<ul class="uk-list">
										<li>
											<div class="uk-flex">
												<div class="icon-check uk-flex-none uk-margin-small-right" uk-icon="check"></div>
												<div>
													Funktionsumfang entspricht der folgenden &bdquo;<span class="text-highlight">Live-Vorschau</span>&ldquo;
												</div>
											</div>
										</li>
										<li>
											<div class="uk-flex">
												<div class="icon-check uk-flex-none uk-margin-small-right" uk-icon="check"></div>
												<div>
													<span class="text-highlight">WordPress-Web-Hosting</span> inkl. SSL-Verschlüsselung (https) mit Adresse:
													<span class="text-highlight" style="white-space: nowrap"><i>dein-firmenname</i>.immonex.one</span>
												</div>
											</div>
										</li>
										<li>
											<div class="uk-flex">
												<div class="icon-check uk-flex-none uk-margin-small-right" uk-icon="check"></div>
												<div>
													vorhandene <span class="text-highlight">eigene Domain</span> nutzbar
													<meta-info type="toggle">
														beliebiger Anbieter &ndash; Einrichtung kostenfrei &ndash;
														Domain nicht im Grundpreis enthalten
													</meta-info>
												</div>
											</div>
										</li>
										<li>
											<div class="uk-flex">
												<div class="icon-check uk-flex-none uk-margin-small-right" uk-icon="check"></div>
												<div>rechtssicher und DSGVO-konform</div>
											</div>
										</li>
										<li>
											<div class="uk-flex">
												<div class="icon-check uk-flex-none uk-margin-small-right" uk-icon="check"></div>
												<div>
													Aktualisierung der Immobilien-Angebote via <span class="text-highlight" style="white-space: nowrap">OpenImmo-Import-Schnittstelle</span>&nbsp;
													<meta-info type="toggle">
														Die Übermittlung von Immobiliendaten im OpenImmo-XML-Format wird von allen
														gängigen Branchen-Softwarelösungen unterstützt.
													</meta-info>
												</div>
											</div>
										</li>
										<li>
											<div class="uk-flex">
												<div class="icon-check uk-flex-none uk-margin-small-right" uk-icon="check"></div>
												<div>professioneller &bdquo;<span class="text-highlight" style="white-space: nowrap">Lead Generator</span>&ldquo; für die Objektakquise</div>
											</div>
										</li>
										<li>
											<div class="uk-flex">
												<div class="icon-check uk-flex-none uk-margin-small-right" uk-icon="check"></div>
												<div>
													Inhalte und Navigation individuell erweiterbar
													<meta-info type="toggle">
														Eigene Seiten und News-Artikel können ganz einfach erstellt und in die
														vorhandene Menüstruktur eingefügt werden.
													</meta-info>
												</div>
											</div>
										</li>
										<li>
											<div class="uk-flex">
												<div class="icon-check uk-flex-none uk-margin-small-right" uk-icon="check"></div>
												<div>
													Einbindung von Bewertungssiegeln und -Widgets
													<meta-info type="toggle">
														z. B. von ImmobilienScout24 oder ProvenExpert
													</meta-info>
												</div>
											</div>
										</li>
										<li v-if="false">
											<div class="uk-flex">
												<div class="icon-check uk-flex-none uk-margin-small-right" uk-icon="check"></div>
												<div class="uk-flex-auto">
													Veröffentlichung aller Angebote auch unter <a href="https://immonex.de/" target="_blank" tabindex="-1">immonex.de</a>&nbsp;
													<meta-info type="toggle">in Kürze verfügbar!</meta-info>
												</div>
											</div>
										</li>
									</ul>
								</div>

								<div class="uk-width-1-2@m">
									<p>Kostengünstig und fair:</p>

									<ul class="prices-and-terms">
										<li><span class="text-highlight">30 Tage</span> kostenlos testen</li>
										<li>
											anschließend <span class="uk-text-danger uk-margin-small-right" style="text-decoration: line-through" v-if="specialDealRegularPrice">{{ specialDealRegularPriceFormatted }}</span>
											<strong class="uk-text-success">{{ basePriceFormatted }}</strong> zzgl. MwSt. pro Monat
											<meta-info type="toggle" icon="warning">nur für Gewerbetreibende (Prüfung im Anschluss an die Anmeldung)</meta-info>
										</li>
										<li>
											Zahlung per SEPA-Lastschrift mit &bdquo;<span class="text-highlight">Immer-Online-Garantie</span>&ldquo;
											<meta-info type="toggle">
												Liquiditätsengpass? Kein Problem! Die Zahlung kann jederzeit per Klick ausgesetzt werden,
												wobei die ONE Website trotzdem verfügbar bleibt - nur Zusatzmodule wie OpenImmo-Import oder
												Lead Generator werden bis zur Wiederaufnahme der regulären Berechnung deaktiviert.
											</meta-info>
										</li>
										<li><span class="text-highlight">keine Mindestlaufzeit</span> (monatlich kündbar)</li>
										<li><span class="text-highlight">keine Einrichtungsgebühr</span></li>
									</ul>
								</div>
							</div>
						</div>

						<div class="uk-text-center">
							<span class="uk-button uk-button-primary uk-button-large uk-margin-bottom" @click="go()">Jetzt kostenlos testen!</span>
							<div class="uk-margin-remove-top uk-light">
								<span class="text-highlight">Null Risiko <span uk-icon="chevron-right"></span></span> sicher &ndash; volle Kostenkontrolle &ndash; kurze Laufzeiten &ndash; direkt online
							</div>
						</div>
					</div>

					<div class="signup-step__company uk-padding-small uk-light" v-show="isCurrentStep('company')">
						<p>Wie lautet der Name deines Unternehmens?</p>
						<div :class="['signup-input', { 'is-valid': isValidStep }, 'uk-inline']">
							<span class="signup-input-icon uk-form-icon uk-form-icon-flip" uk-icon="icon: check" v-if="isValidStep"></span>
							<input name="company" type="text" placeholder="Firma inkl. Rechtsform" tabindex="-1" class="uk-input" v-model="company" @change="getSiteUrlSlug">
						</div>
						<meta-info>
							Diese und weitere Angaben (Kontaktdaten etc.) werden auf verschiedenen Seiten automatisch übernommen.
						</meta-info>
					</div>

					<div class="signup-step__company_display uk-padding-small uk-light" v-show="isCurrentStep('company_display')">
						<p>Alternativer Name?</p>
						<div :class="['signup-input', 'uk-inline']">
							<input name="company_display" type="text" placeholder="alternative Bezeichnung" tabindex="-1" class="uk-input" v-model="companyDisplay" @change="updatePreview">
						</div>
						<meta-info>
							Eine alternative Bezeichnung des Unternehmens kann (optional) an dieser und weiteren Stellen
							der Website	hinterlegt werden, bei denen die Nennung der vollständigen Firmierung nicht
							notwendig ist.
						</meta-info>
					</div>

					<div class="signup-step__country uk-padding-small uk-light" v-show="isCurrentStep('country')">
						<p>Wo befindet sich dein Büro?</p>
						<div class="uk-grid-small" uk-grid>
							<div class="uk-width-1-1">
								<div :class="['signup-input', 'uk-inline', { 'is-valid': isValidAddress }]">
									<span class="signup-input-icon uk-form-icon uk-form-icon-flip" uk-icon="icon: check" v-if="isValidAddress"></span>
									<input name="address" type="text" placeholder="Straße und Hausnummer" tabindex="1" class="uk-input" v-model="address" @change="updatePreview">
								</div>
							</div>
						</div>

						<div class="uk-grid-small" uk-grid>
							<div class="uk-width-1-3 uk-width-1-4@s">
								<div :class="['signup-input', 'uk-inline', { 'is-valid': isValidZipCode }]">
									<span class="signup-input-icon uk-form-icon uk-form-icon-flip" uk-icon="icon: check" v-if="isValidZipCode"></span>
									<input name="zipcode" type="text" placeholder="PLZ" tabindex="2" class="uk-input" v-model="zipCode" @change="updatePreview">
								</div>
							</div>

							<div class="uk-width-2-3 uk-width-3-4@s">
								<div :class="['signup-input', 'uk-inline', { 'is-valid': isValidCity }]">
									<span class="signup-input-icon uk-form-icon uk-form-icon-flip" uk-icon="icon: check" v-if="isValidCity"></span>
									<input name="city" type="text" placeholder="Ort" tabindex="3" class="uk-input" v-model="city" @change="getSiteUrlSlug">
								</div>
							</div>
						</div>

						<div class="uk-grid-small" uk-grid>
							<div class="uk-width-1-1">
								<select name="countrycode" tabindex="4" class="uk-select" v-model="countrycode" @change="updatePreview">
									<option value="DEU">Deutschland</option>
									<option value="AUT">Österreich</option>
									<option value="CHE">Schweiz</option>
									<option value="LUX">Luxemburg</option>
									<option value="BEL">Belgien</option>
									<option value="NED">Niederlande</option>
									<option value="FRA">Frankreich</option>
									<option value="DNK">Dänemark</option>
									<option value="POL">Polen</option>
								</select>
							</div>
						</div>
					</div>

					<div class="signup-step__phone uk-padding-small uk-light" v-show="isCurrentStep('phone') && !activePreviewRequest">
						<p>Unter welcher Haupt-Rufnummer bist du erreichbar?</p>
						<div :class="['signup-input', { 'is-valid': isValidPhone }, 'uk-inline']">
							<span class="signup-input-icon uk-form-icon uk-form-icon-flip" uk-icon="icon: check" v-if="isValidPhone"></span>
							<input name="phone" type="text" placeholder="Telefonnummer, z. B. 0999 123456" tabindex="-1" class="uk-input" v-model="phone" @change="updatePreview">
						</div>
						<meta-info>
							Bitte die Nummer <strong>ohne</strong> internationale Vorwahl (z. B. +49) eingeben.
						</meta-info>
					</div>

					<div class="signup-step__email uk-padding-small uk-light" v-show="isCurrentStep('email') && !activePreviewRequest">
						<p>Deine zentrale E-Mail-Adresse für allgemeine Anfragen?
						<div :class="['signup-input', { 'is-valid': emailIsValid }, { 'is-invalid': isRegularEmail && emailIsValid === false }, 'uk-inline']">
							<span class="signup-input-icon uk-form-icon uk-form-icon-flip" uk-icon="icon: check" v-if="emailIsValid"></span>
							<span class="signup-input-icon uk-form-icon uk-form-icon-flip" uk-icon="icon: warning" v-if="emailIsValid === false"></span>
							<input name="email" type="email" placeholder="E-Mail" tabindex="-1" class="uk-input" v-model="email" @keyup="validateEmail">
						</div>
					</div>

					<div class="signup-step__owner_name uk-padding-small uk-light" v-show="isCurrentStep('owner_name')">
						<p>Wie lautet dein Name?</p>
						<div class="uk-margin-small-bottom">
							<span class="uk-margin-right"><input name="owner_gender" type="radio" value="m" tabindex="1" class="uk-radio" v-model="ownerGender" @change="maybeUpdateOwnerTitle"> Herr</span>
							<input name="owner_gender" type="radio" value="f" class="uk-radio" tabindex="2" v-model="ownerGender" @change="maybeUpdateOwnerTitle"> Frau
						</div>
						<div :class="['signup-input', { 'is-valid': isValidStep }, 'uk-inline']">
							<span class="signup-input-icon uk-form-icon uk-form-icon-flip" uk-icon="icon: check" v-if="isValidStep"></span>
							<input name="owner_name" type="text" placeholder="Vor- und Nachname" tabindex="3" class="uk-input" v-model="ownerName" @change="updatePreview">
						</div>

						<meta-info>
							Die Positionsangabe darunter kannst du im Anschluss an die Anmeldung
							im Administrationsbereich deiner Website bearbeiten.
						</meta-info>
					</div>

					<div class="signup-step__logo uk-padding-small uk-light" v-show="isCurrentStep('logo')">
						<p>Lade das Logo deines Unternehmens hoch und wähle die Grundfarbe deiner Website (optional).</p>
						<div class="uk-grid-small" uk-grid>
							<div class="uk-width-1-1 uk-width-1-2@s">
								<div :class="['logo-crop-container', { 'crosshair-cursor': logoCrosshairCursor }]">
									<croppa
										v-model="logo"
										:width="200"
										:height="150"
										initial-size="contain"
										placeholder="Logodatei auswählen"
										:placeholder-font-size="16"
										:show-remove-button="false"
										:prevent-white-space="false"
										@new-image-drawn="newLogo"
										@move="updatePreview"
										@zoom="updatePreview"
									></croppa>
								</div>

								<div class="image-upload-controls" v-show="logoSelected">
									<span uk-icon="plus-circle" @click="logo.zoomIn()"></span>
									<span uk-icon="minus-circle" @click="logo.zoomOut()"></span>
									<span uk-icon="trash" @click="deleteLogo()"></span>
								</div>
							</div>

							<div class="cd-color-box-wrap uk-width-1-1 uk-width-1-2@s" v-on-clickaway="closeColorPicker">
								<div id="cd-color-box" v-bind:style="{ backgroundColor: this.cdColorPicker.hex }" uk-toggle="target: #cd-color-picker; animation: uk-animation-fade">&nbsp;</div>
								<div id="cd-color-picker" hidden>
									<chrome-picker v-model="cdColorPicker"></chrome-picker>
								</div>
							</div>
						</div>

						<div class="uk-margin-top">
							<meta-info>Das beste Ergebnis erzielst du mit einer PNG-Datei mit transparentem Hintergrund und einer Mindestbreite von 300 Pixeln.</meta-info>

							<meta-info v-if="isSmallDisplay || !logoSelected">Klicken bzw. Tippe zur Auswahl der Farbe in das Farbfeld.</meta-info>
							<meta-info v-if="!isSmallDisplay && logoSelected">Klicken bzw. Tippe zur Auswahl der Farbe in das Farbfeld oder in den entsprechenden Bereich des Logos.</meta-info>
						</div>
					</div>

					<div class="signup-step__owner_photo uk-padding-small uk-light" v-show="isCurrentStep('owner_photo')">
						<p>
							Bitte recht freundlich! <span uk-icon="happy"></span> Hier kannst du (optional)
							dein Portraitfoto hochladen, das auf der Startseite sowie auf der Seite
							&bdquo;Über uns&ldquo; zu sehen sein wird.
						</p>

						<div id="photo-croppa" class="uk-width-1-1">
							<croppa
								v-model="photo"
								:auto-sizing="true"
								initial-size="cover"
								placeholder="Fotodatei auswählen"
								:placeholder-font-size="16"
								canvas-color="#FFF"
								:show-remove-button="false"
								:prevent-white-space="true"
								class="photo-crop-container"
								@new-image-drawn="newPhoto"
								@move="updatePreview"
								@zoom="updatePreview"
							></croppa>

							<div class="image-upload-controls" v-show="photoSelected">
								<span uk-icon="plus-circle" @click="photo.zoomIn()"></span>
								<span uk-icon="minus-circle" @click="photo.zoomOut()"></span>
								<span uk-icon="trash" @click="deletePhoto()"></span>
							</div>
						</div>

						<meta-info>
							Du hast hier auch die Möglichkeit, dein Foto passend zu skalieren bzw. zu zentrieren.
						</meta-info>
					</div>

					<div class="signup-step__supervisory_authority uk-padding-small uk-light" v-show="isCurrentStep('supervisory_authority')">
						<p>
							Bitte hinterlege hier die genaue Bezeichnung sowie die postalische Anschrift
							der <strong>aktuell</strong> für dein Unternehmen zuständigen Aufsichtsbehörde.
						</p>
						<div :class="['signup-input', { 'is-valid': isValidStep }, 'uk-inline']">
							<textarea name="supervisory_authority" placeholder="Aufsichtsbehörde" class="uk-textarea" v-model="supervisoryAuthority" @change="updatePreview"></textarea>
						</div>
						<meta-info>Hier können auch weitere Kontaktdaten wie Telefonnummer oder Web-Adresse ergänzt werden.</meta-info>
					</div>

					<div class="signup-step__finish uk-padding-large uk-padding-remove-bottom" v-show="isCurrentStep('finish')">
						<div class="uk-grid-small" uk-grid>
							<div class="uk-width-1-1 uk-width-1-2@m uk-light">
								<h3>Deine Daten im Überblick</h3>

								<div class="caption">Dein Name</div>
								<p>
									<strong>{{ ownerName }}</strong><br>
								</p>

								<div class="caption">Firma &amp; Anschrift</div>
								<p>
									<strong>{{ company }}</strong><br>
									{{ address }}<br>
									{{ zipCode }} {{ city }}<br>
									{{ country }}
								</p>

								<div class="caption">Fon & E-Mail</div>
								<p>
									{{ phone }}<br>
									{{ email }}
								</p>

								<div class="caption">Aufsichtsbehörde</div>
								<p style="white-space: pre-line">{{ supervisoryAuthority }}</p>

								<meta-info>
									Du kannst im Anschluss an die Anmeldung alle Daten im Administrationsbereich
									(WordPress-Backend) deiner Website bearbeiten.
								</meta-info>
							</div>

							<div class="uk-width-1-1 uk-width-1-2@m uk-light">
								<h3>Deine Web-Adresse</h3>

								<p>
									Deine immonex ONE Website ist gleich unter der folgenden Adresse (URL) erreichbar. Du hast
									hier die Möglichkeit, diese selbst anzupassen, sofern deine Wunschadresse noch verfügbar ist.
								</p>

								<div class="uk-flex uk-flex-middle">
									<div class="text-highlight">{{ siteProtocol }}&nbsp;</div>
									<div :class="['signup-input', 'uk-width-expand', { 'is-valid': isValidStep && siteSlugIsValid }, { 'is-invalid': !siteSlugIsValid }, 'uk-inline']">
										<span class="signup-input-icon uk-form-icon uk-form-icon-flip" uk-icon="icon: check" v-if="isValidStep && siteSlugIsValid"></span>
										<span class="signup-input-icon uk-form-icon uk-form-icon-flip" uk-icon="icon: warning" v-if="!siteSlugIsValid"></span>
										<input name="site_slug" type="text" placeholder="Website-Wunschdomain" :class="['uk-input']" v-model="siteSlug" @change="validateSiteUrlSlug">
									</div>
									<div class="text-highlight">&nbsp;.{{ siteSld }}</div>
								</div>

								<h4>Eigene Domain (extern)</h4>

								<p>
									Du hast bereits eine Domain bei einem beliebigen Anbieter registriert, die du für deine neue Website
									verwenden möchten? Gib diese einfach hier an, wir melden uns dann kurzfristig bzgl. der für die
									Einrichtung nötigen Schritte.
								</p>

								<div class="signup-input">
									<input name="custom_domain" type="text" placeholder="dein-firmenname.de" tabindex="-1" class="uk-input uk-width-1-1 uk-width-medium@m" v-model="customDomain">
								</div>

								<meta-info>Eine eigene Domain kann auch später ergänzt werden.</meta-info>
							</div>

							<div class="uk-width-1-1 uk-margin-top uk-margin-bottom">
								<div class="uk-flex uk-flex-center uk-flex-middle">
									<div class="uk-margin-small-right"><input type="checkbox" class="uk-checkbox" v-model="termsAccepted" style="width:32px; height:32px"></div>
									<div class="uk-text-large uk-light">Mit meiner Anmeldung akzeptiere ich die <a href="#terms-modal" tabindex="-1" uk-toggle>Allgemeinen Geschäftsbedingungen</a>.</div>
								</div>
							</div>

							<div class="uk-width-1-1 uk-text-center">
								<button class="uk-button uk-button-primary uk-button-large uk-width-1-1 uk-width-auto@m" :disabled="!isCreatable">Website jetzt anlegen!</button>
							</div>
						</div>
					</div>

					<div :class="[{ 'uk-padding-small': signupInProgress }, { 'uk-padding-large': !signupInProgress } ]" v-show="currentStep > 0 && !activePreviewRequest">
						<span class="uk-icon-button uk-button-primary" uk-icon="icon: arrow-left; ratio: 2" @click="go('prev')"></span>
						<span class="uk-icon-button uk-button-primary uk-align-right" uk-icon="icon: arrow-right; ratio: 2" @click="go('next')" v-if="signupInProgress && isValidStep"></span>
					</div>

					<div class="uk-padding-small" v-show="signupInProgress && !activePreviewRequest">
						<progress class="uk-progress" :value="currentStep" :max="steps.length - 1"></progress>
					</div>

				</div><!-- .inner-wrap -->

				<div class="arrow-down"></div>

			</div><!-- #signup-step -->

		</form>

		<portal to="signup-overlays"></portal>
	</div>
</template>

<script>
import UIkit from 'uikit'
import axios from 'axios'
import { Chrome } from 'vue-color'
import { mixin as clickaway } from 'vue-clickaway'
import ColorThief from '@codemotion/color-thief'
import scrollIntoView from 'smooth-scroll-into-view-if-needed'

export default {
	name: 'signup',
	data () {
		return {
			signupEnabled: 0,
			company: '',
			companyDisplay: '',
			ownerGender: 'f',
			ownerName: '',
			ownerTitle: 'Inhaberin',
			address: '',
			zipCode: '',
			city: '',
			countrycode: 'DEU',
			phone: '',
			email: '',
			supervisoryAuthority: '',
			logo: {},
			photo: {},
			cdColorPicker: { hex: '#E77805' },
			cdColorScheme: 'dark',
			customDomain: '',
			termsAccepted: false,
			pointerPosition: { x: 0, y: 0 },
			siteProtocol: '',
			siteSlug: '',
			siteSld: '',
			emailIsValid: null,
			siteSlugIsValid: true,
			inTransition: false,
			signupInProgress: false,
			signupCompleted: false,
			activePreviewRequest: false,
			signupStepElInit: true,
			signupStepEl: null,
			signupStepPosDummyEl: null,
			initialSignupStepElTop: 0,
			currentStep: 0,
			ownerPhotoResetted: false,
			steps: [],
			uiLocked: false,
			apiToken: '',
			refId: '',
			group: {},
			affiliate: {},
			basePrice: 39,
			specialDealRegularPrice: 0,
			specialDealLabel: ''
		}
	},
	computed: {
		isSmallDisplay () {
			return this.$mq === 's' || this.$mq === 'm'
		},
		currentStepName () {
			return typeof this.steps[this.currentStep] !== 'undefined' && this.steps[this.currentStep].name ? this.steps[this.currentStep].name : ''
		},
		logoSelected () {
			return this.logo.hasOwnProperty('hasImage') && this.logo.hasImage()
		},
		photoSelected () {
			return this.photo.hasOwnProperty('hasImage') && this.photo.hasImage()
		},
		logoCrosshairCursor () {
			return this.logo.hasOwnProperty('hasImage') && this.logo.hasImage()
		},
		isValidAddress () {
			return this.address.length >= 5 && this.address.match(/[0-9]/)
		},
		isValidZipCode () {
			return this.zipCode.match(/^[0-9]{4,5}$/)
		},
		isValidCity () {
			return this.city.length >= 3
		},
		isValidPhone () {
			return this.phone.length >= 6 && this.phone.match(/[0-9+\-/ ]+/)
		},
		isRegularEmail () {
			const expression = /\S+@\S+\.[a-zA-Z]{2,}/
			return expression.test(String(this.email).toLowerCase())
		},
		isValidStep () {
			if (this.currentStepName === 'company' && this.company.length < 3) return false
			if (this.currentStepName === 'owner_name' && this.ownerName.length < 6) return false
			if (this.currentStepName === 'country') {
				if (!this.isValidAddress) return false
				if (!this.isValidZipCode) return false
				if (!this.isValidCity) return false
			}
			if (this.currentStepName === 'phone' && !this.isValidPhone) return false
			if (this.currentStepName === 'email' && !this.emailIsValid) return false
			if (this.currentStepName === 'supervisory_authority' && this.supervisoryAuthority.length < 16) return false

			return true
		},
		isCreatable () {
			return this.company && this.ownerName && this.address && this.zipCode
				&& this.city && this.phone && this.email && this.supervisoryAuthority
				&& this.siteSlug && this.siteSlugIsValid && this.termsAccepted
		},
		basePriceFormatted () {
			return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.basePrice)
		},
		specialDealRegularPriceFormatted () {
			return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.specialDealRegularPrice)
		},
		country () {
			let countries = {
				DEU: 'Deutschland',
				AUT: 'Österreich',
				CHE: 'Schweiz',
				LUX: 'Luxemburg',
				BEL: 'Belgien',
				NED: 'Niederlande',
				FRA: 'Frankreich',
				DNK: 'Dänemark',
				POL: 'Polen'
			}

			return countries[this.countrycode]
		}
	},
	watch: {
		// eslint-disable-next-line
		'cdColorPicker.hex': function(newValue, oldValue) {
			this.updateCdColorScheme(newValue)
		}
	},
	methods: {
		isCurrentStep (name) {
			return this.steps.length > this.currentStep && this.currentStepName === name
		},
		go (step = 'next') {
			var orgStep = this.currentStep

			switch (step) {
				case 'next':
					if (this.currentStep < this.steps.length) {
						this.currentStep++
					}
					break
				case 'prev':
					if (this.currentStep > 0) {
						this.currentStep--
					}
					break
			}

			if (this.currentStep === orgStep) return

			const currentStepName = this.steps[this.currentStep].name
			if (
				currentStepName === 'start' ||
				currentStepName === 'finish'
			) {
				if (currentStepName === 'finish') this.sendToPreview({ type: 'home' })
				var transition1 = () => new Promise(resolve => {
					this.inTransition = true

					requestAnimationFrame(() => {
						const style = window.getComputedStyle(this.signupStepEl)
						this.signupStepEl.style.position = 'relative'
						this.signupStepEl.style.left = '0'
						this.signupStepEl.style.marginLeft = this.isSmallDisplay || this.$mq === 'l' ? '0' : style.left
						this.signupStepEl.style.top = ''
						this.signupStepEl.style.width = ''

						resolve()
					})
				})

				var transition2 = () => new Promise(resolve => {
					requestAnimationFrame(() => {
						this.signupStepPosDummyEl.style.top = this.initialSignupStepElTop + 'px'
						this.signupStepPosDummyEl.style.width = this.signupStepEl.offsetWidth + 'px'
						this.signupStepPosDummyEl.style.height = this.signupStepEl.offsetHeight + 'px'

						this.$nextTick(() => {
							scrollIntoView(this.signupStepPosDummyEl, {
								behavior: 'smooth',
								block: this.isSmallDisplay ? 'start' : 'center',
								inline: this.isSmallDisplay ? 'start': 'center',
								scrollMode: 'if-needed'
							})

							this.signupInProgress = false
							resolve()
						})
					})
				})

				transition1().then(transition2)
			} else  {
				var transition4 = () => new Promise(resolve => {
					this.inTransition = true

					if (
						(this.currentStep === 1 && orgStep === 0) ||
						(this.currentStep === this.steps.length - 2 && orgStep === this.steps.length - 1)
					) {
						requestAnimationFrame(() => {
							const style = window.getComputedStyle(this.signupStepEl)

							this.signupStepEl.style.position = 'absolute'
							this.signupStepEl.style.left = style.marginLeft
							this.signupStepEl.style.marginLeft = '0px'

							resolve()
						})
					} else {
						resolve()
					}
				})

				var transition5 = () => new Promise(resolve => {
					this.signupInProgress = true
					this.getPreviewElementPosition(this.steps[this.currentStep].name)

					if (this.isCurrentStep('owner_photo')) {
						this.updatePreview()
					}

					resolve()
				})

				transition4().then(transition5)
			}
		},
		// eslint-disable-next-line
		async setSignupOverlayPosition (left, top, elWidth = 0, elHeight = 0) {
			top += 20 + parseInt(window.getComputedStyle(document.getElementById('preview-wrap')).paddingTop)

			const arrow = document.querySelector('#signup-step.signup-started > .arrow-up')
			let arrowOffsetLeft = arrow && elWidth > 0 ? elWidth / 2 : 40
			if (arrowOffsetLeft < 40) arrowOffsetLeft = 40

			if (!this.isSmallDisplay) {
				left += 20
				this.signupStepEl.style.left = left + 'px'
				this.signupStepPosDummyEl.style.left = left + 'px'
				arrow.style.left = arrowOffsetLeft + 'px'
				this.signupStepEl.style.left = left + 'px'
			} else if (arrow) {
				arrow.style.left = (left + arrowOffsetLeft) + 'px'
			}

			this.signupStepEl.style.top = top + 'px'
			this.signupStepPosDummyEl.style.top = top + 'px'
			this.signupStepPosDummyEl.style.height = this.signupStepEl.offsetHeight + 'px'

			await this.$nextTick()

			scrollIntoView(this.signupStepPosDummyEl, {
				behavior: 'smooth',
				block: 'center',
				inline: 'center'
			})
		},
		showSignupSlide (name) {
			const slides = this.$refs.formslides.getElementsByTagName('li')

			for (let i = 0; i < slides.length; i++) {
				if (slides[i].id === 'signup-slide-' + name) {
					UIkit.slideshow(this.$refs.formslides).show(i)
					break
				}
			}
		},
		async getSiteUrlSlug () {
			const that = this

			if (!this.companyDisplay) {
				this.companyDisplay = this.company
			}

			await this.fetchApiToken()

			axios.post(process.env.VUE_APP_API_BASE_URL + '/site-urls', {
					company: this.companyDisplay,
					city: this.city
				})
				.then(function (response) {
					if (response.status === 200) {
						that.siteProtocol = response.data.data.protocol
						that.siteSlug = response.data.data.slug
						that.siteSld = response.data.data.sld
						that.siteSlugIsValid = true
						that.updatePreview()
					}
				})
				// eslint-disable-next-line
				.catch(error => {
					return false
				})
		},
		async updateCdColorScheme (color) {
			const plainHex = color.substring(1, 7)
			const that = this

			await this.fetchApiToken()

			axios.post(process.env.VUE_APP_API_BASE_URL + '/site-color-schemes/' + plainHex)
				.then(function (response) {
					if (response.status === 200) {
						that.cdColorScheme = response.data.data.scheme
						that.updatePreview()
					}
				})
				// eslint-disable-next-line
				.catch(error => {
					return false
				})
		},
		async validateEmail () {
			if (!this.isRegularEmail) {
				this.emailIsValid = null
				return false
			}

			const that = this
			this.emailIsValid = null

			await this.fetchApiToken()

			axios.get(process.env.VUE_APP_API_BASE_URL + '/site-email-addresses/' + this.email)
				.then(function (response) {
					that.emailIsValid = response.status === 200 &&
						response.data.code === 'valid' ? true : false
					if (that.emailIsValid) that.updatePreview()
				})
				// eslint-disable-next-line
				.catch(error => {
					that.emailIsValid = false
				})
		},
		async validateSiteUrlSlug () {
			const that = this

			await this.fetchApiToken()

			axios.get(process.env.VUE_APP_API_BASE_URL + '/site-urls/' + this.siteSlug)
				.then(function (response) {
					if (response.status === 200) {
						that.siteSlug = response.data.data.slug
						that.siteSlugIsValid = response.data.code === 'valid' ? true : false
					} else {
						that.siteSlugIsValid = false
					}
				})
				// eslint-disable-next-line
				.catch(error => {
					that.siteSlugIsValid = false
				})
		},
		maybeUpdateOwnerTitle () {
			if (this.ownerGender === 'm' && this.ownerTitle === 'Inhaberin') {
				this.ownerTitle = 'Inhaber'
				this.updatePreview()
			} else if (this.ownerGender === 'f' && this.ownerTitle === 'Inhaber') {
				this.ownerTitle = 'Inhaberin'
				this.updatePreview()
			}
		},
		async newLogo () {
			const colorThief = new ColorThief();
			const dominantColor = colorThief.getColor(this.logo.getCanvas())

			if (dominantColor) {
				this.cdColorPicker = { hex: '#' + ((1 << 24) + (dominantColor[0] << 16) +
					(dominantColor[1] << 8) + dominantColor[2]).toString(16).slice(1) }
			}
		},
		deleteLogo () {
			this.cdColorPicker = { hex: '#E77805' }
			this.logo.remove()
		},
		newPhoto () {
			// Muss drin sein wegen Croppa-Rendering-Bug...
			document.getElementById('photo-croppa').style.visibility = 'hidden';
			setTimeout( function() { document.getElementById('photo-croppa').style.visibility = 'visible' }, 0 )

			this.updatePreview()
		},
		deletePhoto () {
			this.photo.remove()
			this.updatePreview()
		},
		saveClickPointerPosition (event) {
			this.pointerPosition = { x: event.pageX, y: event.pageY }
		},
		maybePickCdColor (event) {
			if (
				event.pageX === this.pointerPosition.x &&
				event.pageY === this.pointerPosition.y
			) {
				// Canvas-Inhalt wurde NICHT verschoben: Logo-Hintergrundfarbe setzen.
				this.pickCdColor(event.pageX, event.pageY)
			}
		},
		pickCdColor (x, y) {
			if (!this.logo.hasImage()) return

			const canvas = this.logo.getCanvas()
			const context = this.logo.ctx
			const canvasOffset = this.getElementPosition(canvas)

			const imgData = context.getImageData(parseInt(x - canvasOffset.left) * 2, parseInt(y - canvasOffset.top) * 2, 1, 1)
			const red = imgData.data[0]
			const green = imgData.data[1]
			const blue = imgData.data[2]
			const alpha = imgData.data[3]

			if (alpha > 0) this.cdColorPicker = { hex: '#' + ((1 << 24) + (red << 16) + (green << 8) + blue).toString(16).slice(1) }
		},
		closeColorPicker () {
			const cdColorBox = document.getElementById('cd-color-box');
			const picker = document.getElementById('cd-color-picker');
			if (getComputedStyle(picker, null).display === 'block') UIkit.toggle(cdColorBox).toggle();
		},
		async getBrandingData (includeImages = false) {
			let brandingData = {
				type: 'branding_data',
				ref_id: this.refId,
				company: this.company,
				owner_gender: this.ownerGender,
				owner_name: this.ownerName,
				owner_title: this.ownerTitle,
				address: this.address,
				zipcode: this.zipCode,
				city: this.city,
				countrycode: this.countrycode,
				country: this.country,
				focus_area_prefix: 'in',
				focus_area: this.city,
				phone: this.phone,
				email: this.email,
				supervisory_authority: this.supervisoryAuthority,
				cd_color: this.cdColorPicker.hex,
				ba_scheme: this.cdColorScheme,
				site_slug: this.siteSlug,
				custom_domain: this.customDomain
			}

			if (this.companyDisplay) {
				brandingData['company_display'] = this.companyDisplay
			} else if (this.company) {
				brandingData['company_display'] = this.company
			}

			if (includeImages) {
				const logo = this.logo.generateDataUrl()
				const photo = this.photo.generateDataUrl()

				brandingData['logo'] = logo
				brandingData['owner_photo'] = photo

				if (
					!this.ownerPhotoResetted &&
					!brandingData['owner_photo'] &&
					this.isCurrentStep('owner_photo')
				) {
					brandingData['owner_photo'] = 'reset'
					this.ownerPhotoResetted = true
				}
			}

			return brandingData
		},
		getPreviewElementPosition (name) {
			this.activePreviewRequest = true;
			this.lockUi(true)
			this.sendToPreview({ type: 'get_position', name: name })
		},
		async updatePreview () {
			this.sendToPreview(JSON.stringify(await this.getBrandingData(true)))
		},
		async uploadLogo (siteId) {
			if (!this.apiToken) return false
			if (!this.logo.hasImage()) return true

			const logo = await this.logo.promisedBlob('image/png')

			return axios.post(process.env.VUE_APP_API_BASE_URL + '/sites/' + siteId + '/images/logo',
				logo, { headers: { 'Content-Type': 'image/png' } })
				.then(response => {
					return response.status === 200
				})
				// eslint-disable-next-line
				.catch(error => {
					return false
				})
		},
		async uploadPhoto (siteId) {
			if (!this.apiToken) return false
			if (!this.photo.hasImage()) return true

			const photo = await this.photo.promisedBlob('image/jpeg', 0.8)

			return axios.post(process.env.VUE_APP_API_BASE_URL + '/sites/' + siteId + '/images/owner_photo',
				photo, { headers: { 'Content-Type': 'image/jpeg' } })
				.then(response => {
					return response.status === 200
				})
				// eslint-disable-next-line
				.catch(error => {
					return false
				})
		},
		async signup () {
			const that = this
			const brandingData = await this.getBrandingData()

			this.lockUi(true)

			await this.fetchApiToken()

			axios.post(process.env.VUE_APP_API_BASE_URL + '/sites', brandingData)
				.then(async response => {
					if (response.status === 200) {
						let siteId = response.data.data.site_id
						let logoUpload = await that.uploadLogo(siteId)
						let photoUpload = await that.uploadPhoto(siteId)
						let imageUploadErrors = ! logoUpload || ! photoUpload

						that.lockUi(false)
						that.signupCompleted = true
						that.$router.replace({ name: 'signup-success', params: {
							url: response.data.data.url,
							email: brandingData.email,
							imageUploadErrors: imageUploadErrors
						} })
						window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
					} else {
						that.signupError()
					}
				})
				// eslint-disable-next-line
				.catch(error => {
					that.signupError()
				})

			return false
		},
		signupError () {
			this.lockUi(false)

			let content = '<p>Beim Anlegen deiner Website ist leider ein Problem aufgetreten.</p>'
			content += '<p>Wir werden uns schnellstmöglich darum kümmern und melden uns dann bei dir!</p>'

			this.$router.replace({ name: 'error', params: { message: content }})
		},
		lockUi (lock) {
			window.setTimeout(() => {
				this.uiLocked = lock
			}, 500)
		},
		getElementPosition (el) {
			var x = 0
			var y = 0

			while (el) {
				x += el.offsetLeft - el.scrollLeft + el.clientLeft
				y += el.offsetTop - el.scrollTop + el.clientTop
				el = el.offsetParent
			}

			return {
				left: x,
				top: y
			}
		},
		sendToPreview (data) {
			const preview = document.getElementById('preview').contentWindow
			preview.postMessage(data, process.env.VUE_APP_PREVIEW_URL)
		},
		receiveFromPreview (event) {
			// Do we trust the sender of this message? (might be
			// different from what we originally opened, for example).
			// if (event.origin !== "http://example.com")
			// return;

			this.activePreviewRequest = false

			if (
				typeof event.data === 'object' &&
				event.data.type
			) {
				switch (event.data.type) {
					case 'position':
						this.lockUi(false)
						this.$nextTick(() => {
							this.setSignupOverlayPosition(event.data.left, event.data.top, event.data.width, event.data.height)
						});
						break
					case 'preview_ready':
						this.lockUi(false)
						break
				}
			} else {
				if (event.data === 'update_branding') {
					this.updatePreview(event)
				}
			}
		},
		async updatePricingData () {
			await this.fetchGroupData()
			if (this.refId) {
				await this.fetchAffiliateData()
			}

			const group = this.group
			const affiliate = this.affiliate
			const discountPct = affiliate.discount_pct ? Number(affiliate.discount_pct) : 0
			const groupBasePrice = group.base_price ? Number(group.base_price) : 0
			const regularBasePrice = groupBasePrice > 0 ? groupBasePrice : this.basePrice;

			if ( discountPct > 0 &&	discountPct <= 25 ) {
				this.basePrice = regularBasePrice - (regularBasePrice * discountPct / 100)
				this.specialDealRegularPrice = regularBasePrice
				this.specialDealLabel = discountPct + ' % Partnervorteil von ' + affiliate.name + '!'
			} else if (groupBasePrice > 0) {
				this.basePrice = groupBasePrice

				if (group.special_deal_regular_price) {
					this.specialDealRegularPrice = Number(group.special_deal_regular_price)
				}

				if ( typeof this.affiliate.name !== 'undefined' ) {
					this.specialDealLabel = 'Partner-Angebot von ' + affiliate.name + '!'
				} else if (group.special_deal_label) {
					this.specialDealLabel = group.special_deal_label
				}
			}
		},
		async fetchGroupData () {
			const that = this

			await this.fetchApiToken()

			await axios.get(process.env.VUE_APP_API_BASE_URL + '/groups/default')
				.then(function (response) {
					if (response.status === 200) {
						that.group = response.data.data
					}
				})
				// eslint-disable-next-line
				.catch(error => {
					// TODO: Fehlerbehandlung
				})
		},
		async fetchAffiliateData () {
			const that = this

			await this.fetchApiToken()

			await axios.get(process.env.VUE_APP_API_BASE_URL + '/affiliates/' + this.refId)
				.then(function (response) {
					if (response.status === 200) {
						that.affiliate = response.data.data
					}
				})
				// eslint-disable-next-line
				.catch(error => {
					// kein passender Affiliate gefunden... egal!
				})
		},
		async fetchApiToken () {
			const that = this

			if (this.apiToken) return this.apiToken

			await axios.post(process.env.VUE_APP_API_AUTH_BASE_URL + '/token', {}, {withCredentials: true})
				.then(function (response) {
					if (response.status === 200 && response.data.token) {
						that.apiToken = response.data.token
						axios.defaults.headers.common['Authorization'] = 'Bearer ' + that.apiToken
					}
				})
				// eslint-disable-next-line
				.catch(error => {
					// TODO: Fehlerbehandlung
				})
		}
	},
	components: {
		'chrome-picker': Chrome
	},
	mixins: [ clickaway ],
	mounted () {
		const signupStepContainers = document.querySelectorAll('div[class*="signup-step__"]')
		for (let i = 0; i < signupStepContainers.length; i++) {
			let name = signupStepContainers[i].className.match(/signup-step__([a-z_]+)/)
			this.steps.push({ name: name[1] })
		}

		this.signupStepEl = document.getElementById('signup-step')
		this.initialSignupStepElTop = this.signupStepEl.offsetTop
		this.signupStepPosDummyEl = document.getElementById('signup-step-pos-dummy')

		const style = window.getComputedStyle(this.signupStepEl)

		// this.signupStepEl.style.position = 'absolute'
		this.signupStepEl.style.left = style.marginLeft
		this.signupStepEl.style.marginLeft = '0px'
		//this.signupStepEl.style.left = '0px'
		//this.signupStepEl.style.marginLeft = style.marginLeft
		this.$nextTick(() => {
			this.signupStepElInit = false
		})

		const logoCanvas = this.logo.getCanvas()

		function getTransitionEventName () {
			const el = document.createElement('fakeelement')
			const transitions = {
				'WebkitTransition': 'webkitTransitionEnd',
				'MozTransition': 'transitionend',
				'MSTransition': 'msTransitionEnd',
				'OTransition': 'oTransitionEnd',
				'transition': 'transitionEnd'
			}

			for (let t in transitions){
				if (el.style[t] !== undefined) {
					return transitions[t]
				}
			}
		} // getTransitionEventName

		this.signupStepEl.addEventListener(getTransitionEventName(), () => {
			this.inTransition = false
		})

		logoCanvas.addEventListener('mousedown', event => {
			this.$parent.$emit('croppa-canvas-mousedown', event)
		})

		logoCanvas.addEventListener('mouseup', event => {
			this.$parent.$emit('croppa-canvas-mouseup', event)
		})

		this.$parent.$on('croppa-canvas-mousedown', event => { this.saveClickPointerPosition(event) })
		this.$parent.$on('croppa-canvas-mouseup', event => { this.maybePickCdColor(event) })

		window.addEventListener('message', this.receiveFromPreview, false)

		if (this.$route.params['ref_id']) {
			this.refId = this.$route.params['ref_id']
		}

		this.updatePricingData()
	}
}
</script>

<style lang="scss">
@import "@/assets/styles/variables.scss";

$signup-step-bg-color: rgba(60, 59, 49, .96); /* #3C3B31; */
$signup-step-loading-bg-color: rgba(60, 59, 49, .8);
/* $signup-step-bg-color: #2f2f54; */

#loading {
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	margin: .5 -.5em -.5em .5em;
	z-index: 100;
	background-color: $signup-step-loading-bg-color;
	border-radius: .2em;
}

#special-deal-label {
	font-size: 1em;
	padding: .5em;
}

#signup-step-pos-dummy {
	position: absolute;
	width: 0;
	height: 0;
	left: 0;
	top: 0;
}

#signup-step {
	position: relative;
	top: 3.25em;
	left: 0;
	right: 0;
	width: 100%;
	max-width: 1200px;
	margin: auto;
}

#signup-step:not(.init) {
	transition: all 1.5s ease;
}

#signup-step.signup-started {
	position: absolute;
}

#signup-step > .inner-wrap {
	background-color: $signup-step-bg-color;
	border-radius: .2em;
	box-shadow: .5em .5em 1em rgba(0, 0, 0, .4);

	.prices-and-terms > li {
		padding-bottom: .5em;
	}
}

#signup-step > .inner-wrap > div {
	transition: opacity 1s;
}

#signup-step.in-transition > .inner-wrap > div {
/*	opacity: .1 !important; */
}

#signup-step > .arrow-down,
#signup-step.signup-started > .arrow-up {
	display: block;
	left: 50%;
	border: solid transparent;
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
	border-width: 20px;
	margin-left: -20px;
}

#signup-step > .arrow-down {
	top: 100%;
	border-top-color: $signup-step-bg-color;
}

#signup-step.signup-started > .arrow-up {
	bottom: 100%;
	border-bottom-color: $signup-step-bg-color;
}

#signup-step.signup-started > .arrow-down {
	display: none;
}

#signup-step > .arrow-up {
	display: none;
}

.signup-input,
.signup-input > input,
.signup-input > textarea {
	width: 100%;
}

.signup-input.is-valid > .signup-input-icon {
	color: #32D296;
}

.signup-input.is-valid > input,
.signup-input.is-valid > input:focus,
.signup-input.is-valid > textarea,
.signup-input.is-valid > textarea:focus {
	color: #32D296;
	border-color: #32D296;
}

.signup-input.is-invalid > input,
.signup-input.is-invalid > input:focus,
.signup-input.is-invalid > textarea,
.signup-input.is-invalid > textarea:focus {
	color: #F00;
	border-color: #F00;
	background-color: #700000;
}

.signup-input.is-invalid > .signup-input-icon {
	color: #F00;
}

.logo-crop-container {
	width: 200px;
	height: 150px;
	margin: 0 auto;
	border: 1px solid #E5E5E5;
}

.logo-crop-container.crosshair-cursor .croppa-container {
	cursor: crosshair;
}

.croppa-container {
	width: 100%;
	height: 100%;
	background-color: #FFF;
}

.croppa-container canvas {
	width: 200px;
	height: 150px;
	max-width: 100%;
}

.croppa-container > svg {
	position: absolute;
	right: 0;
	top: 0;
}

#photo-croppa {
	text-align: center;
}

.croppa-container.photo-crop-container {
	width: 180px;
	height: 180px;
	margin-bottom: 1em;
	border: 1px solid #E5E5E5;
	-webkit-clip-path: circle(90px at 50% 50%);
	clip-path: circle(90px at 50% 50%);
	cursor: move;
}

.cd-color-box-wrap {
	position: relative;
	text-align: center;
	margin-top: 2em;
}

#cd-color-box {
	display: inline-block;
	width: 150px;
	height: 150px;
	border: 1px solid #E5E5E5;
	cursor: pointer;
	vertical-align: top;
	-webkit-clip-path: circle(75px at 50% 50%);
	clip-path: circle(75px at 50% 50%);
}

#cd-color-picker {
	position: absolute;
	top: 1rem;
	left: 2rem;
}

.caption {
	font-size: .8em;
	text-transform: uppercase;
}

.icon-check {
	color: #32D296;
	cursor: none;
}

.image-upload-controls {
	margin-top: 1em;
	text-align: center;
}

/* UIkit */

/* Screen S */
@media screen and (min-width: $screen-s) {
	.cd-color-box-wrap {
		margin-top: 0;
	}
}

/* Screen M */
@media screen and (min-width: $screen-m) {
	#special-deal-label {
		position: absolute;
		right: -4px;
	}

	#signup-step.signup-started,
	#signup-step-pos-dummy.signup-started {
		width: 500px;
		margin-left: 1em;
		margin-right: 0;
	}

	.logo-crop-container {
		margin: 0;
	}

	.signup-step__logo .image-upload-controls {
		text-align: left;
	}

	.signup-step__start .meta-info {
		max-width: 75%;
	}
}
</style>
